<script lang="ts" setup>
import systemLogoLocal from '@/assets/images/login-logo.png';
import { localStg } from '@/utils/storage';
defineOptions({ name: 'SystemLogo' });
interface IProp {
  height?: number;
  width?: number;
  logo: any;
}
const props = withDefaults(defineProps<IProp>(), {
  height: 30,
  width: 34,
});

const height = computed(() => `h-${props.height}px`);

const width = computed(() => `h-${props.width}px`)

// const systemLogo = computed(() => localStg.get('sysConfig')?.companyLogo || systemLogoLocal)

</script>

<template>
  <!-- <icon-local-logo /> -->
  <img :src="logo" :class="['logo', `${height}`, `${width}`]" />
</template>

<style scoped></style>
